import $ from 'jquery';
import RevealWhenVisible from '../../components/reveal-when-visible';
import ScrollTo from '../../components/scroll-to';
import ProductTradeIn from './components/product-trade-in';
import ProductVariantColorSelect from '../../components/product-variant-color-select';
import IframeFullHeight from '../../components/iframe-full-height';
import ModalVideoWithParameters from '../../components/modal-video-with-parameters';
import SliderWithPagination from '../../components/slider-with-pagination';
$(() => {
    ScrollTo.init();
    RevealWhenVisible.init();
    ProductTradeIn.init();
    ProductVariantColorSelect.init();
    IframeFullHeight.init();
    ModalVideoWithParameters.init();
    SliderWithPagination.init();
});
